//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DataSource from 'devextreme/data/data_source'

//#endregion

import { IDataTypePanelRule, IMRDataTypePanelFormItemOptions, IMRDataTypePanelAdditionalOptions } from '../interfaces'

import { OpDataType } from "../../../../models/core"
import { IReferenceType } from "../../../../models/util/interfaces"

import { LocalizationHelper } from "../../../../helpers"
import { ReferenceTypeService } from '../../../../services/reference-type'
import { DataProviderListResult } from '../../../../data-provider'


export class ReferenceTypeRule implements IDataTypePanelRule {

    //#region Ctor

    public constructor(private readonly referenceTypeService: ReferenceTypeService) { }

    //#endregion


    //#region IDataTypePanelRule Implementation

    public canHandle(opDataType: OpDataType): JQueryPromise<boolean> {
        return $.Deferred<boolean>()
            .resolve(opDataType != null && opDataType.idReferenceType != null)
            .promise()
    }

    public getItemFormFieldOptions(opDataType: OpDataType, additionalOptions?: IMRDataTypePanelAdditionalOptions, isRequired?: boolean, data?: any[]): JQueryPromise<IMRDataTypePanelFormItemOptions> {
        return this
            .buildDataSource(opDataType)
            .then((dataSource: any[]) => {
                const item: IMRDataTypePanelFormItemOptions = {
                    dataField: opDataType.idDataType.toString(),
                    editorType: 'dxSelectBox',
                    validationRules: this.getValidationRules(opDataType, isRequired),

                    editorOptions: {
                        dataSource: new DataSource(dataSource),
                        displayExpr: 'caption',
                        noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                        placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                        searchEnabled: true,
                        valueExpr: 'id',
                        value: _.first(data)
                    },

                    label: {
                        location: 'top',
                        text: opDataType.toString()
                    },
                }

                if (additionalOptions != null && additionalOptions.multiSelect) {
                    item.editorType = 'dxTagBox'

                    item.editorOptions.showSelectionControls = true
                    item.editorOptions.showDropDownButton = true
                    item.editorOptions.multiline = false
                    item.editorOptions.value = data
                }

                return item
            })
    }

    //#endregion


    //#region Private Methods

    private buildDataSource(opDataType: OpDataType): JQueryPromise<any> {
        if (opDataType != null) {
            return this.referenceTypeService
                .getReferenceObjects(opDataType.idReferenceType)
                .then((referenceTypes: DataProviderListResult<IReferenceType>) => {
                    return _.map(referenceTypes.objects, (reference: IReferenceType) => {
                        return {
                            caption: reference.toString(),
                            id: reference.getReferenceKey()
                        }
                    })
                })
        }

        return $.Deferred<any>().resolve([]).promise()
    }

    private getValidationRules(opDataType: OpDataType, isRequired: boolean = false): any[] {
        const validationRules: any[] = []

        if (isRequired) {
            validationRules.push({
                type: "required",
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
            })
        }

        return validationRules
    }

    //#endregion

}